import React from 'react'
import { Alert } from 'element-react'

const AlertSG = () => {
    return (
        <div>
            <Alert
                title="Success Alert"
                type="success"
                description="more text description"
                showIcon={true}
                className="margin-bottom-small"
            />
            <Alert
                title="Info Alert"
                type="info"
                description="more text description"
                showIcon={true}
                className="margin-bottom-small"
            />
            <Alert
                title="Warning Alert"
                type="warning"
                description="more text description"
                showIcon={true}
                className="margin-bottom-small"
            />
            <Alert
                title="Error Alert"
                type="error"
                description="more text description"
                showIcon={true}
                className="margin-bottom-small"
            />
        </div>
    )
}

export default AlertSG
